export const checkInConstants = {
    CREATE_REQUEST: 'CHECKIN_CREATE_REQUEST',
    CREATE_SUCCESS: 'CHECKIN_CREATE_SUCCESS',
    CREATE_FAILURE: 'CHECKIN_CREATE_FAILURE',

    IDENTIFY_REQUEST: 'CHECKIN_IDENTIFY_REQUEST',
    // IDENTIFY_SUCCESS: 'CHECKIN_IDENTIFY_SUCCESS',
    IDENTIFY_VALIDATED: 'CHECKIN_IDENTIFY_VALIDATED',
    IDENTIFY_RETRY: 'CHECKIN_IDENTIFY_RETRY',
    IDENTIFY_FAILURE: 'CHECKIN_IDENTIFY_FAILURE',

    REFRESH_STATUS_REQUEST: 'CHECKIN_REFRESH_STATUS_REQUEST',
    REFRESH_STATUS_SUCCESS: 'CHECKIN_REFRESH_STATUS_SUCCESS',
    REFRESH_STATUS_FAILURE: 'CHECKIN_REFRESH_STATUS_FAILURE',

    ADD_COMMENT_REQUEST: 'CHECKIN_ADD_COMMENT_REQUEST',
    ADD_COMMENT_SUCCESS: 'CHECKIN_ADD_COMMENT_SUCCESS',
    ADD_COMMENT_FAILURE: 'CHECKIN_ADD_COMMENT_FAILURE',

    REFRESH_SUBSCRIPTIONS: 'CHECKIN_REFRESH_SUBSCRIPTIONS',

    NOTIFICATION: 'CHECKIN_NOTIFICATION',
    RESET: 'CHECKIN_RESET'
};